<app-loader *ngIf="loader"></app-loader>


<form [formGroup]="VendorBankForm" (ngSubmit)="onSubmit()">

    <div class="flex justify-content-between align-items-center mt-3">
        <div class="flex">
            <p-button [label]="(VendorBankForm.get('VendorBankAccountId')?.value || 0) > 0 ? 'Update' : 'Save'"
                icon="pi pi-save" size="small" type="submit" [disabled]="loader">
            </p-button> 
    
            <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" class="p-button-outlined ml-2"
                (onClick)="ref.close()" [disabled]="loader">
            </p-button> 
        </div>
    
        <div>
            <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>
    </div>

    <div class="grid mt-3">

        <div class="col-12 md:col-6">

            <div class="field">
                <label class="block label-required">Account Holder Name</label>
                <input pInputText class="w-full" formControlName="AccountHolderName"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.AccountHolderName.invalid}" />
            </div>

            <div class="field">
                <label class="block label-required">Bank Name</label>
                <input pInputText class="w-full" formControlName="BankName"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.BankName.invalid}" />
            </div>

        </div>

        <div class="col-12 md:col-6">

            <div class="field">
                <label class="block label-required">Account Number</label>
                <input pInputText class="w-full" formControlName="AccountNumber"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.AccountNumber.invalid}" />
            </div>

            <div class="field">
                <label class="block label-required">IFSC</label>
                <input pInputText class="w-full" formControlName="IFSC"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.IFSC.invalid}" />
            </div>

        </div>

    </div>
</form>

<p-toast></p-toast>
